import type { ApiRequest, ApiResponse, ApiTransport } from '@/api/transport';
import { matchRoute } from './handlers';
// Регистрация маршрутов каталога, канвасов и тарифов (side-effect import).
import './catalogHandlers';
import './canvasDocHandlers';
import './billingHandlers';

const MIN_LATENCY_MS = 120;
const MAX_LATENCY_MS = 320;

/**
 * Mock-адаптер: тот же контракт транспорта, данные из src/mocks. Латентность
 * имитируется, чтобы состояния загрузки были видны при ревью.
 */
export class MockTransport implements ApiTransport {
  async send(request: ApiRequest): Promise<ApiResponse> {
    const url = new URL(request.path, 'http://mock.local');
    const match = matchRoute(request.method, url.pathname);
    const latency = MIN_LATENCY_MS + Math.random() * (MAX_LATENCY_MS - MIN_LATENCY_MS);
    await new Promise((resolve) => setTimeout(resolve, latency));

    if (!match) {
      if (import.meta.env.DEV)
        console.warn(`[api:mock] no handler for ${request.method} ${url.pathname}`);
      return {
        status: 404,
        body: { message: `Mock: no handler for ${request.method} ${url.pathname}` },
      };
    }

    const body = (request.body && typeof request.body === 'object' ? request.body : {}) as Record<
      string,
      unknown
    >;
    try {
      return match.handler({ req: request, params: match.params, query: url.searchParams, body });
    } catch (error) {
      console.error('[api:mock] handler failed', error);
      return { status: 500, body: { message: 'Mock handler failed' } };
    }
  }

  beacon(path: string, payload: unknown): boolean {
    void this.send({ method: 'POST', path, body: payload, headers: {} });
    return true;
  }
}
